// Module
var code = "<div class=\"container log-detail-container\">\n    <div style=\"max-width: 750px; margin: auto\">\n        <lb-provision-ajs [selected-log]=\"selectedLog\"></lb-provision-ajs>\n    </div>\n </div>\n";
// Exports
module.exports = code;